var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 1.71875C16.5312 1.875 17 2.46875 17 3.125C17 10.8125 10.75 17 3.09375 17C2.4375 17 1.84375 16.5625 1.6875 15.9062L1.03125 12.9688C0.875 12.2812 1.21875 11.5938 1.84375 11.3125L5.03125 9.96875C5.59375 9.71875 6.28125 9.875 6.6875 10.375L7.71875 11.625C9.34375 10.7188 10.7188 9.375 11.5938 7.75L10.3438 6.71875C9.84375 6.3125 9.6875 5.625 9.9375 5.0625L11.3125 1.875C11.5625 1.25 12.25 0.90625 12.9375 1.0625L15.875 1.71875ZM3.15625 15.5C9.9375 15.4688 15.4688 9.96875 15.5 3.1875L12.6562 2.53125L11.3438 5.59375L13.4688 7.34375C12 10.4375 10.4062 12.0312 7.3125 13.5L5.5625 11.375L2.5 12.6875L3.15625 15.5Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.23a5cd7b05c7f7cb65e2d0d2371423c0.svg";
export { ForwardRef as ReactComponent };